import React, { useState } from "react";
import { Dropdown } from "semantic-ui-react";
import { Modal, message, Form, Alert, Spin } from "antd";
import { useMutation, useQueryClient, useQuery } from "react-query";
import SystemPermissionsToggles from "./SystemPermissionsToggles";
import { UnlockFilled } from "@ant-design/icons";
import { AuthIntegrationApi, AxiosEmployeeAPI } from "../Api";
import { useSettingValue } from "../../utils/Hooks";

import _ from "lodash";

export const EmployeeManagerAccessModal = ({ employee_id }) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const queryClient = useQueryClient();

  const isEditEmployeeScreenEnabled = useSettingValue(
    "T005_EMPLOYEE_EDITING_SCREEN_ENABLED",
  );

  const { data: employee } = useQuery(
    ["employee", employee_id],
    () => AxiosEmployeeAPI.getById({ employee_id, expand: "user" }, {}),
    {
      enabled: !!employee_id && open,
      initialValue: null,
    },
  );

  const UUID = employee?.user?.uuid;

  const { mutate: editUserSystemAccess, isLoading: submitLoading } =
    useMutation(
      ["edit_user_system_acess", UUID],
      (data) => {
        return AuthIntegrationApi.editPermissions(data);
      },
      {
        onSuccess: (values) => {
          queryClient.setQueryData(["permissions", UUID], values.systems);

          message.success("Alteração de acessos feita com sucesso!");
          setOpen(false);
        },
        onError: () =>
          message.error("Não foi possível realizar a alteração dos acessos!"),
      },
    );

  const {
    data: permissions,
    isLoading: permissionsLoading,
    error: permissionsError,
  } = useQuery(
    ["permissions", UUID],
    () => AuthIntegrationApi.getPermissions(UUID),
    {
      enabled: !!UUID && open,
      initialValue: [],
      retry: 0,
    },
  );

  const onCancel = () => {
    form.resetFields();
    setOpen(false);
  };

  const handleSubmit = (values) => {
    const data = {
      user: UUID,
      systems: _(values.systems_permissions).pickBy().keys().value(),
    };
    editUserSystemAccess(data);
  };

  return (
    <>
      {!isEditEmployeeScreenEnabled && (
        <Dropdown.Item
          text="Gerenciar Acessos"
          icon={<UnlockFilled style={{ marginRight: "11px" }} />}
          onClick={() => setOpen(true)}
        />
      )}
      <Modal
        centered
        open={open}
        style={{ maxWidth: "800px" }}
        title={`Alterar ${employee?.first_name} ${employee?.last_name}`}
        okText={"Confirmar"}
        cancelText={"Cancelar"}
        onCancel={onCancel}
        onOk={form.submit}
        width={800}
        confirmLoading={submitLoading || permissionsLoading}
        okButtonProps={{
          disabled: !UUID,
        }}
      >
        {permissionsLoading ? (
          <Spin active="true" />
        ) : (
          <Form
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            layout={"vertical"}
            form={form}
            style={{ width: "100%" }}
            onFinish={handleSubmit}
            disabled={!UUID || submitLoading}
          >
            {!UUID ? (
              <Alert
                type="error"
                message="O usuário não está sincronizado com o Auth, o gerenciamento de acessos está desabilitado"
              />
            ) : (
              <SystemPermissionsToggles
                employee={employee}
                permissions={permissions}
                permissionsError={permissionsError}
              />
            )}
          </Form>
        )}
      </Modal>
    </>
  );
};
